import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';

import { Container } from './divider.styles';
import { Content } from '../../../theme/layout';
import { PADDING_BIG, PADDING_SIZES } from './divider.constants';

export class Divider extends PureComponent {
  static propTypes = {
    className: PropTypes.any,
    paddingSize: PropTypes.oneOf(PADDING_SIZES),
    horizontalPadding: PropTypes.bool,
    small: PropTypes.bool,
    smallWithoutMargin: PropTypes.bool,
  };

  static defaultProps = {
    paddingSize: PADDING_BIG,
  };

  render() {
    const { paddingSize, horizontalPadding, small, smallWithoutMargin } = this.props;
    const HorizontalWrapper = horizontalPadding ? Content : Fragment;

    return (
      <ThemeProvider theme={{ paddingSize, small, smallWithoutMargin }}>
        <HorizontalWrapper>
          <Container className={this.props.className} />
        </HorizontalWrapper>
      </ThemeProvider>
    );
  }
}
